export interface RuntimePublicConfig {
  privyAppId?: string;
  plaidEdgeFunctionUrl?: string;
  googleClientId?: string;
  googleRedirectUri?: string;
  microsoftClientId?: string;
  microsoftRedirectUri?: string;
}

const buildTimeConfig: RuntimePublicConfig = {
  privyAppId: import.meta.env.VITE_PRIVY_APP_ID as string | undefined,
  plaidEdgeFunctionUrl: import.meta.env.VITE_PLAID_EDGE_FUNCTION_URL as string | undefined,
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined,
  googleRedirectUri: import.meta.env.VITE_GOOGLE_REDIRECT_URI as string | undefined,
  microsoftClientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID as string | undefined,
  microsoftRedirectUri: import.meta.env.VITE_MICROSOFT_REDIRECT_URI as string | undefined,
};

let configPromise: Promise<RuntimePublicConfig> | null = null;
let cachedConfig: RuntimePublicConfig = buildTimeConfig;

function hasRuntimeValue(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

export function mergePublicRuntimeConfig(
  base: RuntimePublicConfig,
  runtime: RuntimePublicConfig,
): RuntimePublicConfig {
  const merged: RuntimePublicConfig = { ...base };
  for (const [key, value] of Object.entries(runtime) as Array<[keyof RuntimePublicConfig, string | undefined]>) {
    if (hasRuntimeValue(value)) {
      merged[key] = value;
    }
  }
  return merged;
}

export function getPublicRuntimeConfigSnapshot(): RuntimePublicConfig {
  return cachedConfig;
}

export async function loadPublicRuntimeConfig(): Promise<RuntimePublicConfig> {
  configPromise ??= fetch('/api/config/public', {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
    .then(async (res) => {
      if (!res.ok) {
        cachedConfig = buildTimeConfig;
        return cachedConfig;
      }
      cachedConfig = mergePublicRuntimeConfig(buildTimeConfig, await res.json() as RuntimePublicConfig);
      return cachedConfig;
    })
    .catch(() => {
      cachedConfig = buildTimeConfig;
      return cachedConfig;
    });

  return configPromise;
}
